<!-- 
<div>
    <form [formGroup]="filterForm">
        <div class="tools">
            <div *ngIf="areas" class=" ">
                <mat-form-field *ngIf="areas.length > 1" appearance="outline" class="full-width">
                    <mat-label>Filtrar materias</mat-label>
                    <mat-select formControlName="materias" multiple>
                        <mat-option *ngFor="let area of areas" [value]="area.id">{{area.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="toolx3">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Mostrar metas</mat-label>
                    <mat-select formControlName="tiposMetas" multiple>
                        <mat-option *ngFor="let tipo of tiposMetasUnidad" [value]="tipo.id">{{tipo.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="toolx1" style="justify-content: center;">
                <mat-slide-toggle formControlName="alumnos">Metas NA/P</mat-slide-toggle>
            </div>
        </div>
    </form>   
</div>
-->

<div class="unidad-metas-container">

    <button mat-icon-button *ngIf="!showMetasReferencia" (click)="showMetasReferencia = !showMetasReferencia"
        matTooltip="Mostrar metas de referencia">
        <mat-icon>chevron_right</mat-icon>
    </button>

    <section class="metas-referencia" *ngIf="showMetasReferencia">

        <div class="flex-wrap">
            <h3 class="mat-h2">Mapa curricular
                <small>Metas de referencia para la unidad</small>
            </h3>
            <span class="spacer"></span>
            <button mat-icon-button (click)="showMetasReferencia = !showMetasReferencia"
                matTooltip="Ocultar metas de referencia">
                <mat-icon>chevron_left</mat-icon>
            </button>
        </div>
        <!-- <p *ngIf="(metas | categoriaFilter: metasRCategorias).length == 0" class="empty">Sin metas asociadas</p>-->
        <!-- 
        <ul [sortablejs]="metas | categoriaFilter: metasRCategorias" [sortablejsOptions]="sortableOptions"
            *ngIf="showMetasReferencia" style="margin-top: 0">
            <ng-container *ngFor="let metaReferencia of metas | categoriaFilter: metasRCategorias">
                <li [attr.data-meta-id]="metaReferencia.id">
                    <unidad-meta [metaUnidad]="metaReferencia" [categorias]="categorias"
                        (eliminar)="eliminarMeta($event)"></unidad-meta>
                </li>
            </ng-container>
        </ul>
         -->
        <div class="categoria">
            <mat-expansion-panel [hideToggle]="true" *ngFor="let metaUnidad of (metas | categoriaFilter: [9])">
                <mat-expansion-panel-header>
                    <div [matTooltip]="metaUnidad.meta.id"><small>{{metaUnidad.meta.txtIdioma}}</small></div>
                </mat-expansion-panel-header>
            </mat-expansion-panel>
        </div>

        <div class="categoria">
            <mat-expansion-panel [hideToggle]="true" *ngFor="let metaUnidad of (metas | categoriaFilter: [2])">
                <mat-expansion-panel-header>
                    <div [matTooltip]="metaUnidad.meta.id"><small>{{metaUnidad.meta.txtIdioma}}</small></div>
                </mat-expansion-panel-header>
            </mat-expansion-panel>
        </div>

    </section>

    <section class="metas-unidad">

        <div class="categoria" *ngIf="(metas | categoriaFilter: [12]).length > 0 && categoriaActiva[12]">
            <h2 class="mat-h2">
                Metas de transferencia
                <small>Los estudiantes podrán usar independientemente su aprendizaje para...</small>
            </h2>
            <!-- 
            <p *ngIf="(metas | categoriaFilter: [12]).length == 0" class="empty">Sin metas asociadas</p>
            <ul [sortablejs]="metas | categoriaFilter: [12]" [sortablejsOptions]="sortableOptions">
                <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [12]">
                    <li [attr.data-meta-id]="metaUnidad.id">
                        <unidad-meta [metaUnidad]="metaUnidad" (eliminar)="eliminarMeta($event)"></unidad-meta>
                    </li>
                </ng-container>
            </ul>
            -->
            <mat-accordion multi="true">
                <mat-expansion-panel *ngFor="let metaUnidad of (metas | categoriaFilter: [12])"
                    [hideToggle]="metaUnidad.meta.criteriosDto.length === 0" matBadgePosition="before"
                    [matBadgeHidden]="metaUnidad.meta.criteriosDto.length === 0" matBadgeSize="small"
                    [matBadge]="metaUnidad.meta.criteriosDto.length" aria-hidden="false">
                    <mat-expansion-panel-header>
                        <div [matTooltip]="metaUnidad.meta.id" matTooltipPosition="before">
                            {{metaUnidad.meta.txtIdioma}}
                        </div>
                    </mat-expansion-panel-header>
                    <div matSubheader *ngIf="metaUnidad.meta.criteriosDto.length > 0">
                        Criterio{{metaUnidad.meta.criteriosDto.length > 1 ? 's' : ''}}:
                    </div>
                    <ul *ngFor="let criterio of metaUnidad.meta.criteriosDto">
                        <li>
                            <div [matTooltip]="criterio.id" matTooltipPosition="before">
                                {{criterio.nombre}}
                            </div>
                            <mat-divider></mat-divider>
                            <ol>
                                <li *ngFor="let nivel of criterio.niveles[0]?.criterios">
                                    <div [matTooltip]="nivel.id" matTooltipPosition="before">
                                        {{nivel.escala.nombre}}: {{nivel?.nombre}}
                                    </div>
                                    <mat-divider></mat-divider>
                                </li>
                            </ol>
                        </li>
                    </ul>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="categoria"
            *ngIf="(metas | categoriaFilter: [13]).length > 0 || (metas | categoriaFilter: [14]).length > 0">
            <h3 class="mat-h2">
                <!-- FIXME: in18 -->
                Metas de comprensión
            </h3>
            <div *ngIf="(metas | categoriaFilter: [13]).length > 0 && categoriaActiva[13]">
                <h4 class="mat-h4 top-space-8">Comprensiones
                    <small>Los estudiantes comprenderán que...</small>
                </h4>
                <!-- <p *ngIf="(metas | categoriaFilter: [13]).length == 0" class="empty">Sin metas asociadas</p>-->
                <!-- 
                <ul [sortablejs]="metas | categoriaFilter: [13]" [sortablejsOptions]="sortableOptions">
                    <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [13]">
                        <li [attr.data-meta-id]="metaUnidad.id">
                            <unidad-meta [metaUnidad]="metaUnidad" (eliminar)="eliminarMeta($event)">
                            </unidad-meta>
                        </li>
                    </ng-container>
                </ul>
                 -->
                <mat-accordion multi="true">
                    <mat-expansion-panel *ngFor="let metaUnidad of (metas | categoriaFilter: [13])"
                        [hideToggle]="metaUnidad.meta.criteriosDto.length === 0" matBadgePosition="before"
                        [matBadgeHidden]="metaUnidad.meta.criteriosDto.length === 0" matBadgeSize="small"
                        [matBadge]="metaUnidad.meta.criteriosDto.length" aria-hidden="false">
                        <mat-expansion-panel-header>
                            <div [matTooltip]="metaUnidad.meta.id" matTooltipPosition="before">
                                {{metaUnidad.meta.txtIdioma}}
                            </div>
                        </mat-expansion-panel-header>
                        <div matSubheader *ngIf="metaUnidad.meta.criteriosDto.length > 0">
                            Criterio{{metaUnidad.meta.criteriosDto.length > 1 ? 's' : ''}}:
                        </div>
                        <ul *ngFor="let criterio of metaUnidad.meta.criteriosDto">
                            <li>
                                <div [matTooltip]="criterio.id" matTooltipPosition="before">
                                    {{criterio.nombre}}
                                </div>
                                <mat-divider></mat-divider>
                                <ol>
                                    <li *ngFor="let nivel of criterio.niveles[0]?.criterios">
                                        <div [matTooltip]="nivel.id" matTooltipPosition="before">
                                            {{nivel.escala.nombre}}: {{nivel?.nombre}}
                                        </div>
                                        <mat-divider></mat-divider>
                                    </li>
                                </ol>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <div *ngIf="(metas | categoriaFilter: [14]).length > 0 && categoriaActiva['14']">
                <h4 class="mat-h4 top-space-8">Preguntas esenciales
                    <small>Los estudiantes seguirán considerando...</small>
                </h4>
                <!-- <p *ngIf="(metas | categoriaFilter: [14]).length == 0" class="empty">Sin metas asociadas</p>-->
                <!-- 
                <ul [sortablejs]="metas | categoriaFilter: [14]" [sortablejsOptions]="sortableOptions">
                    <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [14]">
                        <li [attr.data-meta-id]="metaUnidad.id">
                            <unidad-meta [metaUnidad]="metaUnidad" (eliminar)="eliminarMeta($event)">
                            </unidad-meta>
                        </li>
                    </ng-container>
                </ul>
                -->
                <mat-accordion multi="true">
                    <mat-expansion-panel *ngFor="let metaUnidad of (metas | categoriaFilter: [14])"
                        [hideToggle]="metaUnidad.meta.criteriosDto.length === 0" matBadgePosition="before"
                        [matBadgeHidden]="metaUnidad.meta.criteriosDto.length === 0" matBadgeSize="small"
                        [matBadge]="metaUnidad.meta.criteriosDto.length" aria-hidden="false">
                        <mat-expansion-panel-header>
                            <div [matTooltip]="metaUnidad.meta.id" matTooltipPosition="before">
                                {{metaUnidad.meta.txtIdioma}}
                            </div>
                        </mat-expansion-panel-header>
                        <div matSubheader *ngIf="metaUnidad.meta.criteriosDto.length > 0">
                            Criterio{{metaUnidad.meta.criteriosDto.length > 1 ? 's' : ''}}:
                        </div>
                        <ul *ngFor="let criterio of metaUnidad.meta.criteriosDto">
                            <li>
                                <div [matTooltip]="criterio.id" matTooltipPosition="before">
                                    {{criterio.nombre}}
                                </div>
                                <mat-divider></mat-divider>
                                <ol>
                                    <li *ngFor="let nivel of criterio.niveles[0]?.criterios">
                                        <div [matTooltip]="nivel.id" matTooltipPosition="before">
                                            {{nivel.escala.nombre}}: {{nivel?.nombre}}
                                        </div>
                                        <mat-divider></mat-divider>
                                    </li>
                                </ol>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>

        <div class="categoria"
            *ngIf="(metas | categoriaFilter: [16]).length > 0 || (metas | categoriaFilter: [17]).length > 0">
            <h3 class="mat-h2" id="test">
                Metas de adquisición
            </h3>
            <div *ngIf="(metas | categoriaFilter: [16]).length > 0 && categoriaActiva['16']">
                <div>
                    <h4 class="mat-h4 top-space-8">Conocimientos
                        <small>Los estudiantes conocerán...</small>
                    </h4>
                    <!-- <p *ngIf="(metas | categoriaFilter: [16]).length == 0" class="empty">Sin metas asociadas</p> -->
                </div>
                <!-- 
                <ul [sortablejs]="metas | categoriaFilter: [16]" [sortablejsOptions]="sortableOptions">
                    <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [16]">
                        <li [attr.data-meta-id]="metaUnidad.id">
                            <unidad-meta [metaUnidad]="metaUnidad" (eliminar)="eliminarMeta($event)">
                            </unidad-meta>
                        </li>
                    </ng-container>
                </ul>
                 -->
                <mat-accordion multi="true">
                    <mat-expansion-panel *ngFor="let metaUnidad of (metas | categoriaFilter: [16])"
                        [hideToggle]="metaUnidad.meta.criteriosDto.length === 0" matBadgePosition="before"
                        [matBadgeHidden]="metaUnidad.meta.criteriosDto.length === 0" matBadgeSize="small"
                        [matBadge]="metaUnidad.meta.criteriosDto.length" aria-hidden="false">
                        <mat-expansion-panel-header>
                            <div [matTooltip]="metaUnidad.meta.id" matTooltipPosition="before">
                                {{metaUnidad.meta.txtIdioma}}
                            </div>
                        </mat-expansion-panel-header>
                        <div matSubheader *ngIf="metaUnidad.meta.criteriosDto.length > 0">
                            Criterio{{metaUnidad.meta.criteriosDto.length > 1 ? 's' : ''}}:
                        </div>
                        <ul *ngFor="let criterio of metaUnidad.meta.criteriosDto">
                            <li>
                                <div [matTooltip]="criterio.id" matTooltipPosition="before">
                                    {{criterio.nombre}}
                                </div>
                                <mat-divider></mat-divider>
                                <ol>
                                    <li *ngFor="let nivel of criterio.niveles[0]?.criterios">
                                        <div [matTooltip]="nivel.id" matTooltipPosition="before">
                                            {{nivel.escala.nombre}}: {{nivel?.nombre}}
                                        </div>
                                        <mat-divider></mat-divider>
                                    </li>
                                </ol>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <div *ngIf="(metas | categoriaFilter: [17]).length > 0 && categoriaActiva['17']">
                <div>
                    <h4 class="mat-h4 top-space-8">Habilidades
                        <small>Los estudiantes serán capaces de...</small>
                    </h4>
                    <!-- <p *ngIf="(metas | categoriaFilter: [17]).length == 0" class="empty">Sin metas asociadas</p> -->
                </div>
                <!-- 
                <ul [sortablejs]="metas | categoriaFilter: [17]" [sortablejsOptions]="sortableOptions">
                    <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [17]">
                        <li [attr.data-meta-id]="metaUnidad.id">
                            <unidad-meta [metaUnidad]="metaUnidad" (eliminar)="eliminarMeta($event)">
                            </unidad-meta>
                        </li>
                    </ng-container>
                </ul>
                 -->
                <mat-accordion multi="true">
                    <mat-expansion-panel *ngFor="let metaUnidad of (metas | categoriaFilter: [17])"
                        [hideToggle]="metaUnidad.meta.criteriosDto.length === 0" matBadgePosition="before"
                        [matBadgeHidden]="metaUnidad.meta.criteriosDto.length === 0" matBadgeSize="small"
                        [matBadge]="metaUnidad.meta.criteriosDto.length" aria-hidden="false">
                        <mat-expansion-panel-header>
                            <div [matTooltip]="metaUnidad.meta.id" matTooltipPosition="before">
                                {{metaUnidad.meta.txtIdioma}}
                            </div>
                        </mat-expansion-panel-header>
                        <div matSubheader *ngIf="metaUnidad.meta.criteriosDto.length > 0">
                            Criterio{{metaUnidad.meta.criteriosDto.length > 1 ? 's' : ''}}:
                        </div>
                        <ul *ngFor="let criterio of metaUnidad.meta.criteriosDto">
                            <li>
                                <div [matTooltip]="criterio.id" matTooltipPosition="before">
                                    {{criterio.nombre}}
                                </div>
                                <mat-divider></mat-divider>
                                <ol>
                                    <li *ngFor="let nivel of criterio.niveles[0]?.criterios">
                                        <div [matTooltip]="nivel.id" matTooltipPosition="before">
                                            {{nivel.escala.nombre}}: {{nivel?.nombre}}
                                        </div>
                                        <mat-divider></mat-divider>
                                    </li>
                                </ol>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </section>
</div>